(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ThreeVideos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
        const slideItems = document.querySelector('.slide-items'); // 获取滑动容器
        const totalSlides = slideItems.children.length; // 获取slide-item数量
        const slideWidth = slideItems.children[0].clientWidth; // 每个slide的宽度
        let currentIndex = 0; // 当前滑动的索引

        // 左右滑动按钮
        const leftButton = document.querySelector('.control-left');
        const rightButton = document.querySelector('.control-right');

        // 滑动到指定索引
        function goToSlide(index) {
            slideItems.style.transform = `translateX(${-index * slideWidth}px)`; // 根据索引平移
        }

        // 点击右侧按钮滑动到下一个
        rightButton.addEventListener('click', () => {
            if (currentIndex < totalSlides - 1) {
                currentIndex++;
            } else {
                currentIndex = 0; // 如果是最后一个slide，则回到第一个
            }
            goToSlide(currentIndex);
        });

        // 点击左侧按钮滑动到上一个
        leftButton.addEventListener('click', () => {
            if (currentIndex > 0) {
                currentIndex--;
            } else {
                currentIndex = totalSlides - 1; // 如果是第一个slide，则跳到最后一个
            }
            goToSlide(currentIndex);
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
   new Swiper('.focus-carousel .swiper', {
      speed: 400,
        slidesPerView: 1.3,
        centeredSlides: true,
        spaceBetween: 20,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
      autoplay: {
        delay: 6000, // 每3秒切换一张
        disableOnInteraction: true // 用户交互后是否停止自动播放，false 表示不会停止
    },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-2"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  const $section = $('.how-it-works-section-2');
  const $items = $section.find('.list-item > div');
  const $images = $section.find('.image-container > div > img');

  $items.eq(0).addClass('list-item-hover');
  $items.on('click', function () {
    const index = $(this).index();
    $(this).addClass('list-item-hover').siblings().removeClass('list-item-hover');
    $images.eq(index).css('display', 'block').siblings().css('display', 'none');
  });
})(window.jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function ($) {
    const $section = $('.how-it-works-section');
    const $items = $section.find('.list-item > div');
    const $images = $section.find('.image-container > div > img');

    $items.eq(0).addClass('list-item-hover');
    $items.on('click', function () {
      const index = $(this).index();
      $(this).addClass('list-item-hover-1').siblings().removeClass('list-item-hover-1');
      $images.eq(index).css('display', 'block').siblings().css('display', 'none');
    });
  })(window.jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-compare"] && !Shopify.designMode) return;
  try {
    
    class CustomElement extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({mode: 'open'});
            const div = document.createElement('div');
            div.id = 'price_compare';
            shadowRoot.appendChild(div);
          
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = this.getAttribute('stylesheet');
            shadowRoot.appendChild(link);
          
            const scriptVue = document.createElement('script');
            scriptVue.src = this.getAttribute('script')
            scriptVue.type = 'module';
            shadowRoot.appendChild(scriptVue);
        }
    }
    document.addEventListener("DOMContentLoaded", (event) => {
        console.log("DOM fully loaded and parsed");
    });
    customElements.define('custom-element', CustomElement);

  } catch(e) { console.error(e); }
})();
})();
